'use client';

import { Radio, radioTag } from '@ni/nimble-components/dist/esm/radio';
import { wrap } from '../utilities/react-wrapper';

export { radioTag };
export { type Radio };
export const NimbleRadio = wrap(Radio);
